/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
document.addEventListener("variant:added", function (event) {
  var variant = event.detail.variant; // Get the variant that was added
  console.log("test");
  window._conv_q = window._conv_q || [];
  _conv_q.push(["triggerConversion", "100029258"]);
});
window.addEventListener("DOMContentLoaded", (event) => {
  $(".accordion-title").click(function () {
    $(this).toggleClass("active-accordion");
    $(this).next().slideToggle(300);
  });
});

$(document).ready(function () {
  if ($("body").hasClass("temp-name-collection")) {
    all__products();
  }
});

$(document).on("click", "#load_more__js", function () {
  var $el = $(this),
    current_page = parseInt($el.attr("data-current_page"));
  $el.addClass("loading");
  all__products(current_page);
  setTimeout(function () {
    $el.attr("data-current_page", current_page + 1);
  }, 100);
});

function all__products(page = 1) {
  var wrap = document.createElement("div"),
    url = updateQueryStringParameter(window.location.href, "view", "ajax");
  console.log(url, "<<<<<url");
  fetch(url)
    .then((data) => {
      return data.text();
    })
    .then((html) => {
      var doc = document.createElement("div");
      doc.innerHTML = html;
      var item_count = parseInt($(".filter-loadmore--js").attr("item_count")),
        item_count0 = item_count - 1,
        filter_classes = "",
        colls_ids_arr = [],
        $el_prods = doc.querySelector("#list_products__ajax");
      window.globalProducts = sorting(
        $($el_prods).find("[data-variants_inventory]")
      );
      applyProducts(page);
    })
    .catch(function (err) {
      console.log(err);
    });
}

function applyProducts(page = 1) {
  var len = 48,
    startPage = (page - 1) * len,
    endPage = page * len,
    hhttmmll = window.globalProducts,
    total_len = $(window.globalProducts).find(
      "[data-variants_inventory]"
    ).length,
    parts = Math.ceil(total_len / len),
    htmlProds = $(hhttmmll)
      .find("[data-variants_inventory]")
      .slice(startPage, endPage),
    $pagiantion_btn = $("#load_more__js"),
    current_page = $pagiantion_btn.attr("data-current_page");
  console.log(total_len, parts, hhttmmll, window.globalProducts);
  if (page == 1) {
    $("#AjaxinateContainer").html(htmlProds);
  } else {
    if (hhttmmll != null) {
      $("#AjaxinateContainer").append(htmlProds);
    } else {
      console.log("Undefine globalProduct");
      all__products();
    }
  }
  // ajaxCart.load();
  if (parts > 1 && current_page <= parts) {
    $pagiantion_btn.show();
  } else {
    $pagiantion_btn.hide();
  }
  $("#load_more__js").removeClass("loading");
}

var sort_by_attr = function (a, b) {
  return (
    b.getAttribute("data-variants_inventory") -
    a.getAttribute("data-variants_inventory")
  );
};

function sorting($selector) {
  var list = $selector.get();
  list.sort(sort_by_attr);
  var sorted_list = document.createElement("div");
  for (var i = 0; i < list.length; i++) {
    sorted_list.appendChild(list[i]);
  }
  return sorted_list;
}

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf("?") !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, "$1" + key + "=" + value + "$2");
  } else {
    return uri + separator + key + "=" + value;
  }
}

function getUrlVars(URI = "") {
  var vars = [],
    hash;
  if (URI == "") {
    URI = window.location.href;
  }
  var hashes = URI.slice(URI.indexOf("?") + 1).split("&");
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split("=");
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}
